import { Link, useSearchParams } from "react-router-dom";
import { MailCheck, ArrowLeft } from "lucide-react";
import "./LandingPage.css";

export default function SignupComplete() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");

  return (
    <main className="nexus-legal">
      <div className="nexus-legal__shell">
        <Link className="nexus-login__back" to="/">
          <ArrowLeft size={17} aria-hidden="true" />
          Nexus Game Engine
        </Link>
        <p className="nexus-eyebrow">Checkout complete</p>
        <h1>Your Nexus setup invite is on the way.</h1>
        <section>
          <h2>
            <MailCheck size={22} aria-hidden="true" /> Check the Primary
            Administrative Email
          </h2>
          <p>
            Once your payment method is confirmed, Nexus will send a secure
            workspace setup invitation to the email entered during checkout.
            Bank payments may take longer to fully process than card payments.
          </p>
          {sessionId && <p>Session reference: {sessionId}</p>}
          <Link className="nexus-button nexus-button--primary" to="/login">
            Go to Login
          </Link>
        </section>
      </div>
    </main>
  );
}
